<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import Btm from "../components/Btm.svelte";

    import * as store from "../stores/store";
    import { get } from "svelte/store";

    export let params;
    let as_id = params.as_id;
    let data = get(store.selectedAs) || {};
    let filesStartAS = [];
    let filesEndAS = [];

    onMount(() => {
        getData();
    });

    async function getData() {
        const response = await api.get(`/sales/${as_id}`);
        if (response != null && response.code == 200) {
            const initialSales = {
                total_price: data.total_price,
                expense_price: data.expense_price,
                loss_price: data.loss_price,
            };

            data = { ...data, ...response.data };
            if (!response.data.total_price) {
                data.total_price = initialSales.total_price || 0;
                data.expense_price = initialSales.expense_price || 0;
                data.loss_price = initialSales.loss_price || 0;
            }
            const fileDto = response.searchVO || [];
            filesStartAS = fileDto.filter((f) => f.upload_column === "startAS");
            filesEndAS = fileDto.filter((f) => f.upload_column === "endAS");
        }
    }

    function formatPhoneNumber(num) {
        if (!num) return "";
        const digits = String(num).replace(/\D/g, "");
        if (digits.length === 10) {
            if (digits.startsWith("02"))
                return digits.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
            return digits.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else if (digits.length === 11) {
            return digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
        }
        return num;
    }

    import axiosInstance from "../utiles/axios.util";

    // Modal state for images
    let isModalOpen = false;
    let modalImgSrc = "";

    function getImgUrl(url) {
        if (!url) return "";
        if (url.startsWith("http")) return url;

        let baseDomain = axiosInstance.defaults.baseURL.replace("/api/v1/", "");

        if (!url.startsWith("/")) {
            url = "/" + url;
        }
        return baseDomain + url;
    }

    function openModal(src) {
        modalImgSrc = getImgUrl(src);
        isModalOpen = true;
    }
</script>

<div class="main-body custom-partner">
    <div class="main-content scroll-custom">
        <header class="as-header">
            <button class="back-btn" on:click={() => window.history.back()}>
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                >
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <h1>상세 보기</h1>
        </header>

        <div class="as-list-container">
            <!-- 접수 내용 -->
            <div class="detail-section">
                <h2 class="section-title">접수 내용</h2>

                <div class="info-row">
                    <span class="label">A/S 업체</span>
                    <span class="value"
                        >{data.as_cmpn_name || data.cmpn_name || "-"}</span
                    >
                </div>
                <div class="info-row">
                    <span class="label">A/S 기사</span>
                    <span class="value">{data.repair_name || "-"}</span>
                </div>
                <div class="info-row">
                    <span class="label">접수처/수리처</span>
                    <span class="value"
                        >{data.cus_name || "-"}
                        {data.cus_name_rpr
                            ? " / " + data.cus_name_rpr
                            : ""}</span
                    >
                </div>
                <div class="info-row">
                    <span class="label">제품명</span>
                    <span class="value">{data.item_name || "-"}</span>
                </div>
                <div class="info-row">
                    <span class="label">A/S 방문 주소</span>
                    <span class="value"
                        >{data.addr1 || ""} {data.addr2 || ""}</span
                    >
                </div>
                <div class="info-row">
                    <span class="label">연락처</span>
                    <span class="value">{formatPhoneNumber(data.phone)}</span>
                </div>
                <div class="info-row vertical">
                    <span class="label">고객 증상</span>
                    <div class="text-box">{data.symptom_cus || "-"}</div>
                </div>
            </div>

            <!-- 작업 전 내용 -->
            {#if [3, 4, 8, 9].includes(parseInt(data.status))}
                <div class="detail-section">
                    <h2 class="section-title">작업 전 내용</h2>
                    <div class="info-row vertical">
                        <span class="label">증상</span>
                        <div class="text-box">{data.symptom || "-"}</div>
                    </div>

                    {#if filesStartAS.length > 0}
                        <div class="info-row vertical">
                            <span class="label">작업 전 이미지</span>
                            <div class="image-gallery">
                                {#each filesStartAS as file}
                                    <img
                                        src={getImgUrl(file.upload_url)}
                                        alt="작업전"
                                        on:click={() =>
                                            openModal(file.upload_url)}
                                    />
                                {/each}
                            </div>
                        </div>
                    {/if}
                </div>
            {/if}

            <!-- 작업 내용 -->
            {#if [4, 9].includes(parseInt(data.status))}
                <div class="detail-section">
                    <h2 class="section-title">작업 내용</h2>
                    <div class="info-row vertical">
                        <span class="label">처리내역</span>
                        <div class="text-box">{data.note || "-"}</div>
                    </div>

                    {#if filesEndAS.length > 0}
                        <div class="info-row vertical">
                            <span class="label">작업 후 이미지</span>
                            <div class="image-gallery">
                                {#each filesEndAS as file}
                                    <img
                                        src={getImgUrl(file.upload_url)}
                                        alt="작업후"
                                        on:click={() =>
                                            openModal(file.upload_url)}
                                    />
                                {/each}
                            </div>
                        </div>
                    {/if}
                </div>
            {/if}

            <!-- 매출 (작업 완료 상태일 경우) -->
            {#if [4, 9].includes(parseInt(data.status))}
                <div class="detail-section">
                    <h2 class="section-title">매출</h2>
                    <div class="info-row">
                        <span class="label">총 금액(원)</span>
                        <span class="value amount"
                            >{(data.total_price || 0).toLocaleString()}</span
                        >
                    </div>
                    <div class="info-row">
                        <span class="label">지출액(원)</span>
                        <span class="value amount"
                            >{(data.expense_price || 0).toLocaleString()}</span
                        >
                    </div>
                    <div class="info-row">
                        <span class="label">차액(원)</span>
                        <span class="value amount"
                            >{(
                                (data.total_price || 0) -
                                (data.expense_price || 0)
                            ).toLocaleString()}</span
                        >
                    </div>
                    <div class="info-row">
                        <span class="label">손실금액(원)</span>
                        <span class="value amount"
                            >{(data.loss_price || 0).toLocaleString()}</span
                        >
                    </div>
                </div>
            {/if}
        </div>
        <Btm />
    </div>

    <!-- Image Modal -->
    {#if isModalOpen}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div class="modal-overlay" on:click={() => (isModalOpen = false)}>
            <div class="modal-content" on:click|stopPropagation>
                <button
                    class="modal-close"
                    on:click={() => (isModalOpen = false)}>X</button
                >
                <img src={modalImgSrc} alt="확대 이미지" />
            </div>
        </div>
    {/if}
</div>

<style>
    .custom-partner {
        background-color: var(--bg-primary, #f3f4f6);
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }
    .main-content {
        max-width: 1024px;
        margin: 0 auto;
        flex: 1;
        width: 100%;
        background-color: var(--bg-primary, #f3f4f6);
        padding-bottom: 80px;
    }
    .as-header {
        background-color: var(--bg-secondary, #ffffff);
        padding: 18px 16px;
        display: flex;
        align-items: center;
        gap: 16px;
        border-bottom: 1px solid var(--border-color, #e5e7eb);
        position: sticky;
        top: 0;
        z-index: 100;
    }
    .back-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
    }
    h1 {
        font-size: 18px;
        font-weight: 700;
        margin: 0;
        color: var(--text-primary, #111827);
    }

    .as-list-container {
        padding: 16px;
    }

    .detail-section {
        background-color: var(--bg-secondary, #ffffff);
        border-radius: 12px;
        padding: 20px;
        margin-bottom: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
        border: 1px solid var(--border-color, #e5e7eb);
    }

    .section-title {
        font-size: 16px;
        font-weight: 800;
        color: var(--color-primary, #3b82f6);
        margin-top: 0;
        margin-bottom: 16px;
        padding-bottom: 8px;
        border-bottom: 2px solid var(--bg-primary, #f3f4f6);
    }

    .info-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 8px 0;
        border-bottom: 1px solid var(--border-color, #f3f4f6);
    }
    .info-row:last-child {
        border-bottom: none;
    }

    .info-row.vertical {
        flex-direction: column;
        gap: 8px;
    }

    .label {
        font-size: 13px;
        color: var(--text-tertiary, #6b7280);
        font-weight: 600;
        width: 100px;
        flex-shrink: 0;
    }

    .value {
        font-size: 14px;
        color: var(--text-primary, #111827);
        font-weight: 500;
        text-align: right;
        word-break: break-all;
        flex: 1;
    }
    .value.amount {
        font-weight: 700;
        color: var(--color-primary, #3b82f6);
    }

    .text-box {
        background-color: var(--bg-primary, #f9fafb);
        border-radius: 8px;
        padding: 12px;
        font-size: 14px;
        color: var(--text-primary, #111827);
        width: 100%;
        box-sizing: border-box;
        min-height: 60px;
        white-space: pre-wrap;
        line-height: 1.5;
        border: 1px solid var(--border-color, #e5e7eb);
    }

    .image-gallery {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 4px;
    }

    .image-gallery img {
        width: 80px;
        height: 80px;
        object-fit: cover;
        border-radius: 8px;
        border: 1px solid var(--border-color, #e5e7eb);
        cursor: pointer;
    }

    /* Modal */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .modal-content {
        position: relative;
        max-width: 90%;
        max-height: 90%;
    }

    .modal-content img {
        max-width: 100%;
        max-height: 90vh;
        border-radius: 8px;
    }

    .modal-close {
        position: absolute;
        top: -40px;
        right: 0;
        background: none;
        border: none;
        color: white;
        font-size: 24px;
        cursor: pointer;
        font-weight: bold;
    }
</style>
